import { render, staticRenderFns } from "./InvestmentDetails.vue?vue&type=template&id=41528920&scoped=true&"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js&"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentDetails.vue?vue&type=style&index=0&id=41528920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41528920",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41528920')) {
      api.createRecord('41528920', component.options)
    } else {
      api.reload('41528920', component.options)
    }
    module.hot.accept("./InvestmentDetails.vue?vue&type=template&id=41528920&scoped=true&", function () {
      api.rerender('41528920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Importacao/Pluggy/components/InvestmentDetails.vue"
export default component.exports